<template>
  <footer class="bg-gray-900 text-gray-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- 公司信息 -->
        <div>
          <div class="flex items-center space-x-3 mb-4">
            <div class="w-8 h-8 rounded-full overflow-hidden">
              <img src="/logo.png" alt="猫星球 Logo" class="w-full h-full object-cover" />
            </div>
            <div>
              <h3 class="text-white font-semibold">猫星球</h3>
              <p class="text-xs text-gray-400">科学养猫上猫星球</p>
            </div>
          </div>
          <p class="text-sm leading-relaxed">
            「喵星人的数字乌托邦 —— 科学养宠、趣味社交、智能守护，尽在猫星球」
          </p>
<!--          <div class="flex space-x-4 mt-4">-->
<!--            <a href="#" class="text-gray-400 hover:text-orange-400 transition-colors">-->
<!--              <Facebook class="w-5 h-5" />-->
<!--            </a>-->
<!--            <a href="#" class="text-gray-400 hover:text-orange-400 transition-colors">-->
<!--              <Twitter class="w-5 h-5" />-->
<!--            </a>-->
<!--            <a href="#" class="text-gray-400 hover:text-orange-400 transition-colors">-->
<!--              <Instagram class="w-5 h-5" />-->
<!--            </a>-->
<!--            <a href="#" class="text-gray-400 hover:text-orange-400 transition-colors">-->
<!--              <Youtube class="w-5 h-5" />-->
<!--            </a>-->
<!--          </div>-->
        </div>

        <!-- 快速链接 -->
        <div>
          <h3 class="text-white font-semibold mb-4">快速链接</h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/"
                class="text-sm hover:text-orange-400 transition-colors"
              >
                首页
              </router-link>
            </li>
            <li>
              <router-link
                to="/store"
                class="text-sm hover:text-orange-400 transition-colors"
              >
                商店
              </router-link>
            </li>
            <li>
              <router-link
                to="/ai-doctor"
                class="text-sm hover:text-orange-400 transition-colors"
              >
                AI医生
              </router-link>
            </li>
            <li>
              <router-link
                to="/community"
                class="text-sm hover:text-orange-400 transition-colors"
              >
                社区
              </router-link>
            </li>
            <li>
<!--              <router-link-->
<!--                to="/profile"-->
<!--                class="text-sm hover:text-orange-400 transition-colors"-->
<!--              >-->
<!--                个人资料-->
<!--              </router-link>-->
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <div>
          <h3 class="text-white font-semibold mb-4">联系我们</h3>
          <ul class="space-y-3">
            <li class="flex items-center space-x-3">
              <Mail class="w-4 h-4 text-orange-400" />
              <span class="text-sm">support@catparty.vip</span>
            </li>
            <li class="flex items-center space-x-3">
              <Phone class="w-4 h-4 text-orange-400" />
              <span class="text-sm">+86 0755-32867416</span>
            </li>
            <li class="flex items-center space-x-3">
              <MapPin class="w-4 h-4 text-orange-400" />
              <span class="text-sm">深圳市龙华区民治街道民强社区优城北区 AB 座 1713</span>
            </li>
            <li class="flex items-center space-x-3">
              <Clock class="w-4 h-4 text-orange-400" />
              <span class="text-sm">周一至周日 9:00-21:00</span>
            </li>
          </ul>

          <!-- 应用下载 -->
          <div class="mt-6">
            <h4 class="text-white font-medium mb-3">下载APP</h4>
            <div class="flex space-x-3">
              <a href="#" class="inline-flex items-center px-4 py-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <div class="text-white">
                  <div class="text-xs">Download on the</div>
                  <div class="text-sm font-semibold">App Store</div>
                </div>
              </a>
              <a href="#" class="inline-flex items-center px-4 py-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <div class="text-white">
                  <div class="text-xs">Get it on</div>
                  <div class="text-sm font-semibold">Google Play</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 版权信息 -->
      <div class="border-t border-gray-700 mt-8 pt-8">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-sm text-gray-400">
            © {{new Date().getFullYear()}} 深圳市猫趴科技有限公司 · Powered by 猫趴 & build with 💗
          </p>
          <div class="flex space-x-6 mt-4 md:mt-0">
            <a href="https://catparty.vip/yinsizhengce.html" class="text-sm text-gray-400 hover:text-orange-400 transition-colors">
              隐私政策
            </a>
            <a href="https://catparty.vip/yinsizhengce.html"  class="text-sm text-gray-400 hover:text-orange-400 transition-colors">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import {
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
  Clock
} from 'lucide-vue-next'
</script>

<style scoped>
/* 页脚样式已在global.css中定义 */
</style>

